// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__BIU8j","wrapper":"Hero_wrapper__2Srf0","description":"Hero_description__3UmhR","buttons":"Hero_buttons__1d7-e","thumb":"Hero_thumb__3kyHk"};